import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  categoryStore: [],
};

export const categorySlices = createSlice({
  name: 'categorySlices',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateCategory: (state, action) => {
      state.categoryStore = action.payload;
    },
  },
});

export const { updateCategory } = categorySlices.actions;

// Other code such as selectors can use the imported `RootState` type
export const categoryState = (state: RootState) => state.category.categoryStore;

export default categorySlices.reducer;
